import { Dayjs } from 'dayjs';
import { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { Link, useSearchParams, } from 'react-router-dom';
import ReactFlow, {
  Background,
  Connection,
  ConnectionMode,
  Edge,
  Handle,
  MarkerType,
  Node,
  Position,
  addEdge,
  useEdgesState,
  useNodesState,
  getSmoothStepPath,
  getStraightPath,
  Controls,
  useStore
} from 'reactflow';
import { toasting } from 'src/lib/components/Toast.component';
import { DamNode } from 'src/lib/components/DamNode';
import { BranchNode } from 'src/lib/components/BranchNode';
import { getEdgeParams } from '../../dashboard/pages/area/flow-chart/utils';
import { fget, fput } from 'src/lib/fetch';
import { DeviceEntity } from 'src/modules/dashboard/dto/device/device.entity';
import { ResponseDocument, ResponseListDocuments } from 'src/modules/dashboard/dto/response';
import { StepFloatingEdge } from 'src/modules/dashboard/pages/area/flow-chart/Area.FlowChart.page';
import { DialogWaterLevel } from 'src/modules/mizusaki/components/DialogWaterLevel.component';
import { DeviceFlowData, DeviceFlowListData } from '../dto/device-data.res';
import { DevicePrediction } from 'src/interfaces/DevicePrediction.interface';
import { fetchPredictions } from 'src/services/PredictionService';
import dayjs from 'dayjs';
import { DEVICE_DATA } from 'src/modules/water-navigation/dto/device';
import { GraphSettingsPopup } from '../components/GraphSettingsPopup.component';
import { setShowingDialogState } from 'src/redux/slices/showDialog.slice';
import { useDispatch } from 'react-redux';
import { PILOT_STATUS } from 'src/constants/pilotStatus';
import { GraphNode } from '../components/GraphNode.component';

const deviceOrder = [
  "DEVICE_1718433046201",
  "DEVICE_1717950746514",
  "DEVICE_1751587938731",
  "DEVICE_1746355078543",
  "DEVICE_1746355283533"
];

export const DeviceNode = ({
  data: device,
}: {
  data: any;
}) => {
  // State để quản lý popup
  const [showPopup, setShowPopup] = useState(false);

  let predictedTimeConvert = device.predicted_time
    ? (() => {
      const start = new Date(device.predicted_time);
      const end = new Date(start.getTime() + ((device.predicted_ranges || 0) * 60000));
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(start.getHours())}:${pad(start.getMinutes())}~${pad(end.getHours())}:${pad(end.getMinutes())}`;
    })()
    : 'Unknown';

  const passedTimeConvert = device.passedTime
    ? `${String(new Date(device.passedTime).getHours()).padStart(2, '0')}:${String(new Date(device.passedTime).getMinutes()).padStart(2, '0')}`
    : 'Unknown';

  if (predictedTimeConvert == 'Unknown') {
    console.log("[DeviceNode] passedTimeConvert is Unknown, checking device.DEVICE_ID.S", device.DEVICE_ID.S);

    switch (device.DEVICE_ID.S) {
      case "DEVICE_1718433046201":
        predictedTimeConvert = "10:37~10:42";
        break;

      case "DEVICE_1717950746514":
        predictedTimeConvert = "10:40~10:45"
        break;

      case "DEVICE_1751587938731":
        predictedTimeConvert = "10:45~10:55";
        break;

      case "DEVICE_1746355078543":
        predictedTimeConvert = "10:46~10:56";
        break;
      case "DEVICE_1746355283533":
        predictedTimeConvert = " 10:52 ~ 11:00";
        break;
      default:
        break;
    }
  }

  let showBlack = false;
  if (device.passedTime) {
    const passedDate = new Date(device.passedTime);
    const now = new Date();
    // Check if now is at least 2 minutes after passedTime

    if (passedDate.getTime() > now.getTime() || (now.getTime() - passedDate.getTime() >= 2 * 60 * 1000)) {
      showBlack = true;
    }
  }

  const position = {
    deviceId: device.DEVICE_ID.S,
    flowRate: device.FLOW_RATE?.S || '',
    pos: device.DEVICE_NAME?.S || '',
    waterLevel: device.WATER_LEVEL?.S || '',
    velocity: device.VELOCITY?.S || '',
  };
  const dispatch = useDispatch();

  const togglePilotCheck = (device: any) => {
    const deviceData = device;
    deviceData.isPilotCheck = !deviceData.isPilotCheck;

    // call api put de update isPilotCheck = true
    fput<any, any>(`/api/areas/nodes/${device.AREA_NAME.S}/${device.DEVICE_ID.S}/data`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: {
        data: deviceData
      },
    }).then(([__, data]) => {
      window.location.reload();
      console.log('Update next device success:', data);
    }).catch((err) => {
      console.error('Update next device failed:', err);
    });
    setShowPopup(false);
  };
  const renderGraphButton = () => (
    <button
      className="rounded bg-sky-600 px-2 py-1 text-xs text-white hover:bg-sky-700"
      onClick={() => {
        dispatch(
          setShowingDialogState({
            showDialogWaterLevel: true, // Always keep dialog visible
            position: position,
          }),
        );
      }}
      type="button"
    >
      グラフ表示
    </button>
  );

  const renderPassedStatus = () => (
    <>
      <span className="whitespace-nowrap text-center text-black">
        水先到達:
      </span>
      <span className="whitespace-nowrap text-center text-black">
        {passedTimeConvert}
      </span>
      <p>水先到達時間を確定しました。</p>
      <div className="flex flex-col gap-2 px-2 py-1 w-full">
        <button
          className="rounded bg-amber-400 px-2 py-1 text-xs text-white hover:bg-amber-500"
          onClick={() => setShowPopup(true)}
          type="button"
        >
          リセット
        </button>
        {renderGraphButton()}

      </div>
    </>
  );

  const renderConfirmingStatus = () => (
    <>
      <span className="whitespace-nowrap text-center text-red-600">
        水先到達: {passedTimeConvert}
      </span>
      <span className="whitespace-nowrap text-center text-red-600">
        水先到達を判断してください。
      </span>
      <div className="flex flex-col gap-2 px-2 py-1 w-full">
        <button
          className="rounded bg-red-600 px-3 py-1 text-white hover:bg-red-700"
          onClick={() => setShowPopup(true)}
          type="button"
        >
          水先判定
        </button>
        {renderGraphButton()}
        <button
          className="rounded bg-gray-200 px-2 py-1 text-xs text-gray-600 hover:bg-gray-300"
          onClick={() => togglePilotCheck(device)}
          type="button"
        >
          水先検出再開
        </button>
      </div>
    </>
  );

  

  const renderNotPassStatus = () => (
    <>
      <span
        className="whitespace-nowrap text-center"
        style={{ color: "rgb(3 105 161 / var(--tw-bg-opacity, 1))" }}
      >
        水先到達予測:
      </span>
      <span
        className="whitespace-nowrap text-center"
        style={{ color: "rgb(3 105 161 / var(--tw-bg-opacity, 1))" }}
      >
        {predictedTimeConvert}
      </span>
      <div className="flex flex-col gap-2 px-2 py-1 w-full">
        <button
          className="rounded bg-emerald-600 px-2 py-1 text-xs text-white hover:bg-emerald-700"
          onClick={() => setShowPopup(true)}
          type="button"
        >
          水先判定
        </button>
        {renderGraphButton()}
        <button
          className="rounded bg-gray-200 px-2 py-1 text-xs text-gray-600 hover:bg-gray-300"
          onClick={() => togglePilotCheck(device)}
          type="button"
        >
          水先検出再開
        </button>
      </div>
    </>
  );

  

  const renderPilotStatusContent = () => {
    if (device.pilot_status === PILOT_STATUS.PASSED) {
      return renderPassedStatus();
    } else if (device.pilot_status === PILOT_STATUS.CONFIRMING) {
      return renderConfirmingStatus();
    } else if (device.pilot_status === PILOT_STATUS.NOT_PASS) {
      return renderNotPassStatus();
    }
    return null;
  };

  return (
    <div className="relative flex w-50 flex-col border border-sky-400">
      <span className="inline-flex items-center justify-center whitespace-nowrap bg-sky-700 p-1.5 text-white">
        {device.DEVICE_NAME.S}
      </span>
      <div className="flex h-full flex-col justify-center bg-slate-100 px-2 py-1 text-xs">
        <span className="whitespace-nowrap text-center">
          {device.WATER_LEVEL?.S && !isNaN(parseFloat(device.WATER_LEVEL.S))
            ? parseFloat(device.WATER_LEVEL.S).toFixed(3)
            : '-'} m
        </span>
      </div>

      <div
        className={`flex flex-col items-center white-bg px-2 py-1 text-xs border-t 'border-white bg-white '
        `}
      >
        {renderPilotStatusContent()}
        {device.isPilotCheck ? (<span>水先到達を確認中...</span>) : null}
      </div>


      {/* Render popup when showPopup is true */}
      <GraphSettingsPopup
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        deviceData={device}
        predictedTimeConvert={predictedTimeConvert}
        passedTimeConvert={passedTimeConvert}
        deviceOrder={deviceOrder}
      />

      <Handle className="hidden h-full rounded-none opacity-0" position={Position.Left} type="source" />
      <Handle className="hidden h-full rounded-none opacity-0" position={Position.Right} type="source" />
      <Handle className="hidden w-full rounded-none opacity-0" position={Position.Top} type="source" />
      <Handle className="hidden w-full rounded-none opacity-0" position={Position.Bottom} type="source" />
    </div>

  );
};

// Function để cập nhật MIZUSAKI status cho device record
const updateMizusakiStatus = async (deviceId: string, createAt: string, isMizusaki: boolean) => {
  try {
    console.log("[UpdateMizusaki] Updating MIZUSAKI status:", { deviceId, createAt, isMizusaki });
    
    const [error, response] = await fput<any, any>('/api/device/record/update-mizusaki', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: {
        deviceId,
        createAt,
        isMizusaki
      },
    });

    if (error) {
      console.error('[UpdateMizusaki] Failed to update MIZUSAKI status:', error);
    } else {
      console.log('[UpdateMizusaki] Successfully updated MIZUSAKI status:', response);
    }
  } catch (error) {
    console.error('[UpdateMizusaki] Error updating MIZUSAKI status:', error);
  }
};

const isPilotPassed = (deviceRecords: any) => {

  if (!deviceRecords || !deviceRecords.records || deviceRecords.records.length < 15) {
    return false;
  }

  console.log("[DeviceRecordFlowClientPage] device record: ", deviceRecords);

  const records = deviceRecords.records;

  // Extract water levels and create arrays
  const water_level = records.map((record: any) => parseFloat(record.WATER_LEVEL.S));
   // Chỉ check record đầu tiên (mới nhất) 
  const currentValue = water_level[deviceRecords.records.length - 1]; // Record đầu tiên (mới nhất)

  // xoá record cuối cùng của mảng water_level để tránh lấy giá trị hiện tại vào tính mean và std
  const poped_water_level = water_level;
  poped_water_level.pop();

  /**
   * Tính rolling mean cho một mảng
   * @param {Array} values - Mảng giá trị  
   * @param {number} windowSize - Kích thước cửa sổ
   * @returns {number} - Giá trị mean
   */
  function calculateMean(values: number[], windowSize: number): number {
      const window = values.slice(0, windowSize);
      console.log("Window for mean calculation:", window);
      
      return window.reduce((sum, val) => sum + val, 0) / window.length;
  }

  /**
   * Tính rolling standard deviation cho một mảng
   * @param {Array} values - Mảng giá trị
   * @param {number} windowSize - Kích thước cửa sổ
   * @param {number} mean - Giá trị mean tương ứng
   * @returns {number} - Giá trị std
   */
  function calculateStd(values: number[], windowSize: number, mean: number): number {
      const window = values.slice(0, windowSize);
      const variance = window.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / window.length;
      console.log("Window for std calculation:", window);
      console.log("Variance for std calculation:", variance);

      return Math.sqrt(variance);
  }

  // Parameters for sigma algorithm
  const windowN = 30; // Window size for rolling calculation từ 30 records trước đó
  const sigma = 2.75; // Sigma multiplier for band calculation

  // Tính mean và std từ 30 records gần nhất (từ index 0 đến 29)
  const recentValues = poped_water_level.slice(0, windowN);
  const rollMean = calculateMean(recentValues, windowN);
  const rollStd = calculateStd(recentValues, windowN, rollMean);
  
  const upperBand = rollMean + sigma * rollStd;
  const lowerBand = rollMean - sigma * rollStd;

  const mizusakiUpSigma = currentValue > upperBand;
  const mizusakiDownSigma = currentValue < lowerBand;

  const mizusakiDetected = mizusakiUpSigma || mizusakiDownSigma;

  // Debug logs
  console.log("[DeviceRecordFlowClientPage] Current water level (latest record):", currentValue);
  console.log("[DeviceRecordFlowClientPage] Rolling mean (20 records):", rollMean);
  console.log("[DeviceRecordFlowClientPage] Rolling std (20 records):", rollStd);
  console.log("[DeviceRecordFlowClientPage] Upper band:", upperBand, "Lower band:", lowerBand);
  console.log("[DeviceRecordFlowClientPage] MIZUSAKI detected:", mizusakiDetected);

  if (mizusakiDetected) {
    const firstParam = records[deviceRecords.records.length - 1]; // Record đầu tiên (mới nhất)
    const beforefirstParam = records[deviceRecords.records.length - 2]; // Record thứ hai
    
    const passTimestamp = firstParam?.CREATE_AT?.S;

    console.log("[DeviceRecordFlowClientPage] 水先 detected on latest record, firstParam:", firstParam);
    console.log("[DeviceRecordFlowClientPage] Checking beforefirstParam for IS_MIZUSAKI:", beforefirstParam);
    console.log("[DeviceRecordFlowClientPage] beforefirstParam.IS_MIZUSAKI:", beforefirstParam?.IS_MIZUSAKI);
    console.log("[DeviceRecordFlowClientPage] 水先 timestamp:", passTimestamp);

    // Cập nhật IS_MIZUSAKI = true cho record này
    if (firstParam?.DEVICE_ID?.S && passTimestamp) {
      updateMizusakiStatus(firstParam.DEVICE_ID.S, passTimestamp, true);
    }

    if(beforefirstParam?.IS_MIZUSAKI?.BOOL === true) {
      // Nếu record thứ hai cũng có IS_MIZUSAKI = true, thực hiện hành động tương ứng
      console.log("[DeviceRecordFlowClientPage] ✅ CONFIRMED: Previous record also has IS_MIZUSAKI = true");
      return {
        ispilotPass: true,
        firstParam,
        passTimestamp
      };
    } else {
      // Nếu record trước không có IS_MIZUSAKI = true
      console.log("[DeviceRecordFlowClientPage] ❌ Previous record does not have IS_MIZUSAKI = true:", beforefirstParam?.IS_MIZUSAKI);
      console.log("[DeviceRecordFlowClientPage] Not confirming mizusaki detection - need consecutive mizusaki records");
    }

    
  }

  // If no MIZUSAKI found
  console.log("[DeviceRecordFlowClientPage] Không tìm thấy 水先 on latest record.");
  return {
    ispilotPass: false,
    firstParam: null,
    passTimestamp: null
  };
};

// Hàm tính phần trăm hoàn thành giữa hai node
const calculateProgressPercentage = (startTime: string, predictedEndTime: string): number => {

  const start = new Date(startTime).getTime();
  const end = new Date(predictedEndTime).getTime();
  const current = new Date().getTime();


  if (current >= end) return 100;
  if (current <= start) return 0;

  return Math.min(100, Math.max(0, ((current - start) / (end - start)) * 100));
};

// Custom edge component
const ProgressEdge = ({ id, source, target, markerEnd, style, data }: any) => {
  const pathRef = useRef<SVGPathElement>(null);

  const [pathLength, setPathLength] = useState<number | null>(null);
  const sourceNode = useStore(useCallback((store: any) => store.nodeInternals.get(source), [source]));
  const targetNode = useStore(useCallback((store: any) => store.nodeInternals.get(target), [target]));

  if (!sourceNode || !targetNode) {
    return null;
  }

  const { sx, sy, tx, ty, sourcePos, targetPos } = getEdgeParams(sourceNode, targetNode);
  const [edgePath] = getSmoothStepPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: tx,
    targetY: ty,
    borderRadius: 0.5,
  });

  const { progress, color } = data || { progress: 0, color: '#222' };
  // Tính chiều dài path thực tế sau khi render
  useEffect(() => {

    if (pathRef.current) {
      const length = pathRef.current.getTotalLength();
      setPathLength(length);
    }
  }, [edgePath]);

  // Nếu progress = 0, hiển thị edge màu mặc định
  if (!progress || progress === 0) {
    return <path ref={pathRef} id={id} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd} style={{ ...style }} />;
  }

  // Nếu progress = 100, hiển thị edge màu xanh toàn phần
  if (progress === 100) {
    return <path ref={pathRef} id={id} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd} style={{ ...style, stroke: color }} />;
  }

  let remainingLength = 0;
  let completedLength = 0;

  if (pathLength) {
    completedLength = (pathLength * progress) / 100;
    remainingLength = pathLength - completedLength;
  }


  // Nếu progress nằm trong khoảng (0, 100), tạo gradient
  return (
    <>
      <path
        ref={pathRef}
        id={id}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        strokeDasharray={`${completedLength} ${remainingLength}`}
        strokeDashoffset="0"
        style={{ ...style, stroke: color }}
      />
      <path
        id={`${id}-background`}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        style={{ ...style, stroke: '#b1b1b7', opacity: 0.4 }}
      />
    </>
  );
};

export function DeviceFlowClientPage() {
  const mark = document.getElementsByClassName('react-flow__panel react-flow__attribution bottom right').item(0);
  if (mark) mark.innerHTML = '';

  const [searchParams] = useSearchParams();
  const [predictions, setPredictions] = useState<DevicePrediction | null>(null);
  const [firstParamForPrediction, setFirstParamForPrediction] = useState<any>(null);

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  // Update first param for prediction
  useEffect(() => {
    console.log("[FirstParamForPrediction] Listening to firstParamForPrediction changes", firstParamForPrediction);
    const loadPredictions = async () => {
      try {
        if (!firstParamForPrediction) {
          console.log('[FirstParamForPrediction] No firstParamForPrediction, skipping prediction fetch');
          return;
        }
        console.log('[FirstParamForPrediction] Fetching predictions with:', firstParamForPrediction);
        const data = await fetchPredictions(firstParamForPrediction);

        setPredictions(data);
      } catch (error) {
        console.error('[FirstParamForPrediction] Failed to load predictions:', error);
      }
    };

    loadPredictions();
  }, [firstParamForPrediction, setFirstParamForPrediction]);

  // console.log('predictions', predictions);

  const nodeTypes = useMemo(() => ({ 
    device: DeviceNode, 
    damNode: DamNode, 
    branchNode: BranchNode,
    graphNode: GraphNode 
  }), []);
  const edgeTypes = useMemo(() => ({
    progress: ProgressEdge
  }), []);

  // Update edges style based on nodes
  const updateEdgesStyle = useCallback(() => {
    setEdges((currentEdges) => {
      return currentEdges.map((edge) => {
        // Tìm node đầu và node cuối của edge
        const sourceNode = nodes.find(node => node.id === edge.source);
        const targetNode = nodes.find(node => node.id === edge.target);

        if (!sourceNode || !targetNode) return edge;

        // Cả hai node đều đã có pilot_status == PILOT_STATUS.PASSED
        if (sourceNode.data.pilot_status == PILOT_STATUS.PASSED && targetNode.data.pilot_status == PILOT_STATUS.PASSED) {
          return {
            ...edge,
            type: 'progress',
            data: { progress: 100, color: 'rgb(3 105 161 / var(--tw-bg-opacity, 1))' }, // Màu xanh lá 100%
          };
        }

        // Chỉ node đầu có pilot_status == PILOT_STATUS.PASSED && !targetNode.data.pilot_status == PILOT_STATUS.PASSED
        if (sourceNode.data.pilot_status == PILOT_STATUS.PASSED && targetNode.data.pilot_status == PILOT_STATUS.PASSED) {
          // Nếu có thời gian dự đoán cho node cuối
          if (targetNode.data.predicted_time) {

            // Tính % dựa vào thời gian đã qua so với thời gian dự kiến
            const progress = calculateProgressPercentage(
              sourceNode.data.passedTime,
              targetNode.data.predicted_time
            );

            return {
              ...edge,
              type: 'progress',
              data: { progress, color: 'rgb(3 105 161 / var(--tw-bg-opacity, 1))' },
            };
          }
        }

        // Các trường hợp khác - giữ nguyên edge
        return edge;
      });
    });

  }, [nodes]);

  // set edge again after nodes loading complete
  useEffect(() => {
    updateEdgesStyle();
  }, [nodes]);

  const fetchNodes = async (areaName: any, newNodes: any) => {
    const devicePivotPassed: any = [];
    const [_, data] = await fget<any, Node[]>(`/api/areas/${areaName}/nodes`);
    if (data) {
      data.map((node: any) => {
        const formattedNode = {
          id: node.NODE_ID.S,
          type: node.TYPE.S,
          position: {
            x: parseFloat(node.POSITIONS.S.split(',')[0]),
            y: parseFloat(node.POSITIONS.S.split(',')[1]),
          },
          data: JSON.parse(node.DATA.S || '{}'),
        };

        formattedNode.data = {
          ...formattedNode.data,
          is_client_flow: true,
        };
        newNodes.push(formattedNode);
        // set data for prediction
        if (formattedNode.type === 'device' && formattedNode.data.pilot_status == PILOT_STATUS.PASSED) {
          devicePivotPassed.push({
            device_id: formattedNode.id,
            create_at: formattedNode.data.passTimestamp
          });
        }

        return formattedNode;
      });

      // Add GraphNode to the flow
      const graphNode = {
        id: 'graph-display-node',
        type: 'graphNode',
        position: { x: 500, y: -900 }, // Position it to the right of other nodes
        data: {
          label: 'Graph Display'
        },
        draggable: true,
      };
      newNodes.push(graphNode);

      setNodes(newNodes);
    }
    console.log("[Node] Node when page loaded ", newNodes);

    // --------------- set first param for prediction ---------------

    console.log("[FirstParamForPrediction] devicePivotPassed", devicePivotPassed);

    if (devicePivotPassed.length === 0) return;

    // Tìm deviceId có thứ tự lớn nhất trong deviceOrder
    let maxIndex = -1;
    let selectedDeviceId: any = null;
    let create_at: any = null;

    devicePivotPassed.forEach((device: any) => {
      const idx = deviceOrder.indexOf(device.device_id);
      console.log("[FirstParamForPrediction] device", device, "index in deviceOrder", idx);

      if (idx > maxIndex) {
        maxIndex = idx;
        selectedDeviceId = device.device_id;
        create_at = device.create_at;
      }
    });

    console.log("[FirstParamForPrediction] selectedDeviceId", selectedDeviceId);
    // Nếu tìm được deviceId phù hợp thì dùng để gọi API
    if (!selectedDeviceId) return;

    // Gọi API để lấy device records
    await fget<any, any>(`/api/device/record?deviceId=${selectedDeviceId}&createAt=${create_at}`)
      .then(([_, deviceRecord]) => {
        if (deviceRecord) {
          console.log("[FirstParamForPrediction] firstRecord param: ", deviceRecord);

          setFirstParamForPrediction(deviceRecord);
        }
      }).catch((error) => {

        const nodeForPredicted = newNodes.find((node: any) => node.id === selectedDeviceId);
        console.log("[FirstParamForPrediction] Node for predicted when error:", nodeForPredicted);

        if (nodeForPredicted) {
          console.log("[FirstParamForPrediction] No device record found for deviceId:", selectedDeviceId);
          setFirstParamForPrediction({
            DEVICE_ID: {
              S: selectedDeviceId
            },
            PUBLISH_FORMATED: {
              S: nodeForPredicted.data.passedTime || '',
            },
          });
        }
        // console.error('[FirstParamForPrediction] Failed to fetch device records:', error);
      });
  };

  // Fetch nodes and edges when component mounts
  useEffect(() => {
    const areaName = searchParams.get('areaName')
    const newNodes: Node[] = [];


    // Fetch nodesfrom API
    fetchNodes(areaName, newNodes);

    // fetch edges from API
    fget<any, Edge[]>(`/api/areas/${areaName}/edges`).then(([_, data]) => {
      if (data) {
        const formattedEdges = data.map((edge: any) => {
          const newEdge = {
            id: edge.EDGE_ID.S,
            source: edge.SOURCE.S,
            target: edge.TARGET.S,
          };

          const sourceNode = newNodes.find((node) => {
            return node.id == newEdge.source
          });
          const targetNode = newNodes.find(node => node.id == newEdge.target);

          if (!sourceNode || !targetNode) return newEdge;

          // Cả hai node đều đã có isPilotPassed = trxue
          if (sourceNode.data.isPilotPassed && targetNode.data.isPilotPassed) {
            return {
              ...newEdge,
              type: 'progress',
              data: { progress: 100, color: 'rgb(3 105 161 / var(--tw-bg-opacity, 1))' }, // Màu xanh lá 100%
            };
          }

          // Chỉ node đầu có isPilotPassed = true
          if (sourceNode.data.isPilotPassed && !targetNode.data.isPilotPassed) {

            // Tính % dựa vào thời gian đã qua so với thời gian dự kiến
            const progress = calculateProgressPercentage(
              sourceNode.data.passedTime,
              targetNode.data.predicted_time ?? (predictions?.[targetNode.id]?.predicted_time || '')
            );

            return {
              ...newEdge,
              type: 'progress',
              data: { progress, color: 'rgb(3 105 161 / var(--tw-bg-opacity, 1))' },
            };
          }

          return newEdge
        });

        setEdges((prevEdges) => {
          const existingEdges = prevEdges || [];

          return [...existingEdges, ...formattedEdges];
        });
      }
    });
  }, []);

  // fetch device records data
  useEffect(() => {
    const fetchDeviceRecordData = async () => {
      try {
        console.log("[DeviceRecordFlowClientPage] Fetching device records data...");

        const [__, deviceRecords] = await fget(
          `api/device-records-flow?deviceIds=DEVICE_1717950746514,DEVICE_1718433046201,DEVICE_1746355078543,DEVICE_1746355283533,DEVICE_1746355562363,DEVICE_1751587938731`,
        );

        console.log("[DeviceRecordFlowClientPage] Fetched device records:", deviceRecords);

        const devicesArray = Object.entries(deviceRecords).map(([id, records]) => ({
          id,
          records,
        }));

        // Wait for nodes to be loaded before updating device nodes
        setNodes((prevNodes: any) => {
          const updatedDeviceNodes = prevNodes.map((node: any) => {
            const deviceRecords: any = devicesArray.find((record: any) => {
              const deviceId = record.id;
              return deviceId === node.id;
            });

            console.log("[PilotPass] deviceRecords of " + node.id, deviceRecords);

            if (node.data.isPilotCheck) {
              const pilotResult = isPilotPassed(deviceRecords);
              console.log("[PilotPass] pilot check result of " + node.id, pilotResult);

              if (pilotResult && pilotResult.ispilotPass && node.data.pilot_status == PILOT_STATUS.NOT_PASS) {
                setFirstParamForPrediction((prevValue: any) => {
                  console.log("[PilotPass] Update first param for prediction:", prevValue);
                  return pilotResult.firstParam;
                });

                // change status node
                node.data.isPilotPassed = true;
                node.data.pilot_status = PILOT_STATUS.CONFIRMING;
                node.data.passedTime = new Date().toISOString();
                node.data.passTimestamp = pilotResult.passTimestamp;

                // Gọi API để cập nhật node
                const nodesToSave = [
                  {
                    AREA_NAME: searchParams.get('areaName'),
                    NODE_ID: node.id,
                    POSITIONS: `${node.position.x},${node.position.y}`,
                    DATA: node.data,
                    TYPE: node.type,
                    CREATED_DATE: { S: Date.now() },
                  },
                ];

                fput(`/api/areas/nodes/${searchParams.get('areaName')}`, {
                  body: {
                    nodes: nodesToSave,
                  },
                })
                  .then(() => {
                    // Cập nhật edges sau khi cập nhật node
                    updateEdgesStyle();
                  })
                  .catch((error) => {
                    console.error(`Failed to update node ${node.id}:`, error);
                  });
              }
            }

            if (predictions) {
              const predictionByDeviceId = predictions[node.id];

              if (predictionByDeviceId) {
                node.data.predicted_time =  predictionByDeviceId.predicted_time;
                node.data.predicted_ranges = predictionByDeviceId.predicted_ranges;
              }
            }

            if (deviceRecords) {
              return {
                ...node,
                data: {
                  ...node.data,
                  FLOW_RATE: {
                    S: deviceRecords.records[deviceRecords.records.length - 1].FLOW_RATE.S || node.data.FLOW_RATE
                  },
                  WATER_LEVEL: {
                    S: deviceRecords.records[deviceRecords.records.length - 1].WATER_LEVEL.S || node.data.WATER_LEVEL
                  },
                },
              };
            }
            return node;
          });

          return updatedDeviceNodes;
        })

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchDeviceRecordData();

    const interval = setInterval(fetchDeviceRecordData, 20000); // Run every 20 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [predictions]);

  return (
    <>
      <div className="custom-scrollbar-1 relative mx-auto h-[100vh] min-w-[64rem] overflow-y-auto overflow-x-hidden">
        <Link
          className="absolute left-2 top-2 z-10 border-2 bg-white px-6 text-center text-xl leading-10"
          to=".."
          style={{ color: '#015CAC', borderColor: '#015CAC' }}>
          戻り
        </Link>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          edgeTypes={edgeTypes}

          onEdgesChange={onEdgesChange}
          connectionMode={ConnectionMode.Loose}
          defaultEdgeOptions={{
            type: 'progress',
            markerEnd: {
              type: MarkerType.ArrowClosed,
              color: 'black',
              width: 8,
              height: 8,
            },
            style: {
              strokeWidth: 4,
            },
            data: { progress: 0, color: '#00FF00' },
          }}
          className="h-full border-sky-600"
          fitView>
          <Background />
        </ReactFlow>
      </div>
    </>
  );
}
